<template>
  <Alert class="tw:text-center tw:p-8 tw:mb-0">
    <div class="tw:max-w-sm tw:mx-auto">
      <!-- title slot -->
      <template v-if="slots.title">
        <h3 class="tw:text-base"><slot name="title" /></h3>
      </template>

      <!-- description slot -->
      <slot name="description" />
    </div>

    <template v-if="slots.cta">
      <div class="tw:mt-4">
        <!-- cta slot -->
        <slot name="cta" />
      </div>
    </template>
  </Alert>
</template>
<script setup lang="ts">
import Alert from "@/components/ui/Alert.vue";
import { useSlots } from 'vue';

const slots = useSlots();
</script>
